"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingProvider = void 0;
class TrackingProvider {
    constructor(trackingService, ...trackingHandlers) {
        this.trackingHandlers = [];
        this.trackingService = null;
        this.trackingHandlers = trackingHandlers;
        this.trackingService = trackingService;
    }
    getAllHandlers() {
        return this.trackingHandlers;
    }
    getService() {
        return this.trackingService;
    }
    trackAction(trackingObject) {
        if (this.trackingService)
            this.trackingService.track(trackingObject, this.trackingHandlers);
    }
}
exports.TrackingProvider = TrackingProvider;
